import React, { useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { Grid } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DynamicDropdown';
import { useFilters } from '../FilterContext';
import { makeStyles } from 'tss-react/mui';
import { useRoles } from './hooks/useRoles';
import { useFilterInitialization } from './hooks/useFilterInitialization';
import { SHOW_ALL_OPTION } from '../constants';

const useStyles = makeStyles()((theme) => ({
  roleFilter: {
    '& .dropdown-content': {
      minWidth: '250px'
    }
  }
}));

export const RoleFilter = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { filterValues, updateFilter, isRequired, isShowAll } = useFilters();
  const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));

  const modelVersionId = filterValues.model?.value?.activeModelVersionID;
  const departmentValue = filterValues.department?.value;
  const showAllEnabled = isShowAll('role');
  const roles = useRoles(modelVersionId, showAllEnabled);
  const prevDepartmentRef = useRef();

  // Reset role when department changes
  useEffect(() => {
    const departmentKey = JSON.stringify(departmentValue);
    if (prevDepartmentRef.current !== undefined && prevDepartmentRef.current !== departmentKey) {
      // Department changed - clear role selection
      const defaultValue = showAllEnabled ? SHOW_ALL_OPTION : {};
      updateFilter('role', defaultValue, { roleId: defaultValue.id || '' });
    }
    prevDepartmentRef.current = departmentKey;
  }, [JSON.stringify(departmentValue), updateFilter, showAllEnabled]);

  // Clean, declarative initialization with model and department dependencies
  useFilterInitialization('role', roles, {
    dependencies: [modelVersionId, JSON.stringify(departmentValue)],
    resetOnDependencyChange: true,
    waitForData: true,
    getDefaultValue: () => showAllEnabled ? SHOW_ALL_OPTION : {},
    getParams: (item) => ({ roleId: item.id || '' })
  });

  const handleRoleChange = (item) => {
    updateFilter('role', item, { roleId: item.id || '' });
  };

  if (!filterValues.role) {
    return null;
  }

  return (
    <Grid item lg={3} md={6} xs={12} className={classes.roleFilter}>
      <DyanamicDropdown
        dropDownActiveWidth="auto"
        dataSource={roles}
        dataHeader={[
          {
            id: 1,
            name: `${customCaptions?.role ?? "Role"}`
          }
        ]}
        showHeader
        columns={[{ id: 1, name: "name" }]}
        columnsMinWidths={[250]}
        placeholder={t("placeholder.selectEntity", { entity: customCaptions?.role })}
        width="100%"
        onChange={handleRoleChange}
        selectdValueToshow="name"
        selectedValue={filterValues.role?.value}
        label={t("label.filterByEntity", { entity: customCaptions?.role })}
        isServerSide={false}
        icon={<FilterListIcon style={{ color: "rgb(48, 122, 215)" }} />}
        required={isRequired('role')}
        showBorderColor
      />
    </Grid>
  );
}; 
